module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload"
  }, [(_vm.type === 'image') ? _c('el-upload', {
    ref: "upload",
    attrs: {
      "action": _vm.uploadUlr,
      "data": _vm.uploadData,
      "accept": _vm.imgAccept,
      "file-list": _vm.fileList,
      "on-remove": _vm.imgRemove,
      "on-success": _vm.imgAdd,
      "on-error": _vm.handleError,
      "before-upload": _vm.handleBeforeUpload,
      "limit": 9,
      "disabled": _vm.disabled,
      "on-exceed": _vm.fileUploadLimitHook
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.set_upload_param(_vm.disabled)
      }
    }
  }, [_vm._v("上传图片")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传图片文件，最多上传9张")])], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'file') ? _c('el-upload', {
    ref: "upload",
    attrs: {
      "action": _vm.uploadUlr,
      "data": _vm.uploadData,
      "file-list": _vm.fileList,
      "on-remove": _vm.fileRemove,
      "on-success": _vm.fileAdd,
      "on-error": _vm.handleError,
      "before-upload": _vm.handleBeforeUpload,
      "limit": 9,
      "disabled": _vm.disabled,
      "on-exceed": _vm.fileUploadLimitHook
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.set_upload_param(_vm.disabled)
      }
    }
  }, [_vm._v("上传文件")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("最多上传9个文件")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48698a96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/upload.vue
// module id = 1262
// module chunks = 82